import { urijs } from '../helpers/urijs';
import { getOuterUrl } from './get-outer-url';
export const numberToPage = (page, containsTrailingSlash = false) => `${page > 1 ? `/page/${page}` : ''}${containsTrailingSlash ? '/' : ''}`;
export const createPageUrl = (page, sectionUrl) => {
    const containsTrailingSlash = new urijs(sectionUrl || '').pathname().endsWith('/');
    return getOuterUrl(numberToPage(page, containsTrailingSlash), sectionUrl);
};
export function buildPaginationRequestParams(page, pageSize, cursor) {
    if (page === undefined) {
        return {};
    }
    if (cursor && page > 1) {
        return {
            cursor,
            size: pageSize,
        };
    }
    return {
        offset: (page - 1) * pageSize,
        size: pageSize,
    };
}
export const getLastPage = (entityCount, pageSize = 1) => {
    return Math.ceil(entityCount / pageSize);
};
//# sourceMappingURL=pagination.js.map